import axios from 'axios';
// eslint-disable-next-line no-undef
const { REACT_APP_API_URL } = process.env;

export default axios.create({
  baseURL: REACT_APP_API_URL
})
